/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Seasonal_New_ContentInputs */

const en_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasonal New Trees`)
};

const ar_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار موسمية جديدة`)
};

const de_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Bäume der Saison`)
};

const es_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos árboles de temporada`)
};

const fr_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveaux arbres saisonniers`)
};

const it_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi alberi stagionali`)
};

const ja_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン限定の新しい木`)
};

const ko_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시즌별 신규 나무`)
};

const pt_br_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novas árvores sazonais`)
};

const ru_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые сезонные деревья`)
};

const th_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ใหม่ประจำฤดูกาล`)
};

const tr_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevsimsel Yeni Ağaçlar`)
};

const zh_cn_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当季全新树种`)
};

const zh_tw_subscription_seasonal_new_content = /** @type {(inputs: Subscription_Seasonal_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當季全新樹種`)
};

/**
* | output |
* | --- |
* | "Seasonal New Trees" |
*
* @param {Subscription_Seasonal_New_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_seasonal_new_content = /** @type {((inputs?: Subscription_Seasonal_New_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Seasonal_New_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_seasonal_new_content(inputs)
	if (locale === "ar") return ar_subscription_seasonal_new_content(inputs)
	if (locale === "de") return de_subscription_seasonal_new_content(inputs)
	if (locale === "es") return es_subscription_seasonal_new_content(inputs)
	if (locale === "fr") return fr_subscription_seasonal_new_content(inputs)
	if (locale === "it") return it_subscription_seasonal_new_content(inputs)
	if (locale === "ja") return ja_subscription_seasonal_new_content(inputs)
	if (locale === "ko") return ko_subscription_seasonal_new_content(inputs)
	if (locale === "pt_br") return pt_br_subscription_seasonal_new_content(inputs)
	if (locale === "ru") return ru_subscription_seasonal_new_content(inputs)
	if (locale === "th") return th_subscription_seasonal_new_content(inputs)
	if (locale === "tr") return tr_subscription_seasonal_new_content(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_seasonal_new_content(inputs)
	return zh_tw_subscription_seasonal_new_content(inputs)
});